import React from 'react';

const Icon = ({ size = '51', fill = 'black', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 51 51" fill="none" {...other}>
            <path
                clipRule="evenodd"
                d="M9.414 11.167c0-1.15.933-2.083 2.083-2.083h29.167c1.15 0 2.083.933 2.083 2.083v29.167c0 1.15-.932 2.083-2.083 2.083H11.497a2.083 2.083 0 0 1-2.083-2.083V11.167Z"
                stroke={fill}
                strokeWidth="1.875"
            />

            <path
                d="M19.495 14.41c2.576 0 3.872 2.128 3.872 5.824 0 3.68-1.328 5.824-3.872 5.824-2.544 0-3.872-2.128-3.872-5.824 0-3.68 1.312-5.824 3.872-5.824Zm-2.048 5.824c0 2.928.704 4.304 2.048 4.304 1.36 0 2.048-1.36 2.048-4.304 0-2.928-.72-4.304-2.064-4.304s-2.032 1.456-2.032 4.304Zm7.595 3.44h2.223v2.16h-2.224v-2.16Zm3.909-9.04h7.664v1.52c-2.512 2.8-3.888 5.888-4.176 9.664v.016h-2c.256-3.392 1.872-6.8 4.32-9.568H28.95v-1.632Zm-7.477 16.081c.727 0 1.479.315 1.758 1.042.485-.69 1.127-1.042 1.976-1.042 1.37 0 2.085.69 2.085 2.06v4.377H25.91V33.37c0-.885-.085-1.564-1.14-1.564-1.006 0-1.333.727-1.333 1.625v3.721h-1.382V33.08c0-.776-.243-1.273-1.091-1.273-.873 0-1.383.788-1.383 1.588v3.758H18.2v-6.268h1.31v.873h.036c.485-.715 1.055-1.042 1.928-1.042Zm9.688 0c1.49 0 2.485.679 2.618 1.927h-1.442c-.11-.57-.522-.836-1.273-.836-.68 0-1.14.23-1.14.643 0 .436.376.678 1.588.909 1.928.351 2.473.958 2.473 1.927 0 1.31-1.2 2.037-2.8 2.037-1.649 0-2.74-.74-2.776-2.182h1.382c.085.74.557 1.091 1.418 1.091.849 0 1.394-.242 1.394-.788 0-.436-.279-.764-2.024-1.067-1.043-.182-2.037-.642-2.037-1.867 0-1.176 1.152-1.794 2.619-1.794Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
